import { useMemo } from "react";

import SfEnrichmentJobToggle from "app/pages/sales-intelligence/modules/crm-enrichment/impl/salesforce/containers/SfEnrichmentJobToggle";
import SfJobRemoveModalContainer from "app/pages/sales-intelligence/modules/crm-enrichment/impl/salesforce/containers/SfJobRemoveModalContainer";
import SfJobRenameModalContainer from "app/pages/sales-intelligence/modules/crm-enrichment/impl/salesforce/containers/SfJobRenameModalContainer";
import useSfEnrichmentJobsQuery from "app/pages/sales-intelligence/modules/crm-enrichment/impl/salesforce/query/queries/useSfEnrichmentJobsQuery";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import BaseEnrichmentPreferences from "../../components/BaseEnrichmentPreferences/BaseEnrichmentPreferences";
import type { EnrichmentPreferencesSlots } from "../../components/BaseEnrichmentPreferences/types";
import SalesforceEnrichmentEmptyState from "../EnrichmentEmptyState/SalesforceEnrichmentEmptyState";

type Props = {
    integrationName: Integration;
    isMappingLoading: boolean;
    onEditMapping: VoidFunction;
};

const SfEnrichmentPreferences = ({ integrationName, onEditMapping, isMappingLoading }: Props) => {
    const queryResult = useSfEnrichmentJobsQuery({ polling: true });

    const slots: EnrichmentPreferencesSlots = useMemo(
        () => ({
            renderJobToggle: ({ job, onRenameClick, onDeleteClick }) => (
                <SfEnrichmentJobToggle
                    key={job.id}
                    job={job}
                    onRenameClick={onRenameClick}
                    onDeleteClick={onDeleteClick}
                />
            ),
            renderModals: ({ activeJob, onClearActiveJob }) => (
                <>
                    <SfJobRenameModalContainer
                        job={activeJob}
                        onClose={onClearActiveJob}
                    />
                    <SfJobRemoveModalContainer
                        job={activeJob}
                        onClose={onClearActiveJob}
                    />
                </>
            ),
            renderEmptyState: (emptyStateProps) => (
                <SalesforceEnrichmentEmptyState
                    onEditMapping={emptyStateProps.onEditMapping}
                    isEditDisabled={emptyStateProps.isMappingLoading}
                    onCreateJob={emptyStateProps.onClickAddJob}
                    isCreateJobDisabled={emptyStateProps.isCreateJobDisabled}
                />
            ),
        }),
        [],
    );

    return (
        <BaseEnrichmentPreferences
            integrationName={integrationName}
            isMappingLoading={isMappingLoading}
            onEditMapping={onEditMapping}
            queryResult={queryResult}
            slots={slots}
        />
    );
};

export default SfEnrichmentPreferences;
